<template>
  <div class="relative" id="waybills">
    <div id="header" class="fixed top-0 z-10 flex items-center justify-between w-full p-2 bg-gray-100 border-b shadow-sm">
      <div class="flex items-center">
        <button @click="$router.go(-1)" class="inline-flex items-center justify-center w-8 h-8 mr-2 text-lg leading-none text-gray-500 transition duration-150 bg-transparent rounded hover:bg-white hover:no-underline">
          &larr;
        </button>
        <div class="font-bold">
          Waybills
        </div>
      </div>
      <div>
        <button class="btn btn-accent" @click="print()">
          <fa :icon="['fas', 'print']" class="mr-2 opacity-75" /> Print
        </button>
      </div>
    </div>

    <div id="page">
      <div class="h-1/2" v-for="(order, index) in orders" :key="order.id">
        <div class="border-t border-dashed" v-if="index % 2"></div>
        <div class="p-10 space-y-3">
          <!-- Header -->
          <div class="grid grid-cols-2 gap-3">
            <div class="flex items-center">
              <div class="grid w-24 h-16 mt-1 mr-4 bg-white place-items-center">
                <img :src="$store.state.portal.logo" :alt="$store.state.portal.account" class="max-w-full">
              </div>
              <div class="text-sm leading-tight">
                <div class="font-bold">Community Couriers</div>
                <div>comfort@communitycouriers.co.za</div>
                <div>011 293 0384</div>
              </div>
            </div>
            <div>
              <div class="flex items-center justify-end">
                <div class="text-xs font-semibold leading-tight tracking-wide text-right uppercase">
                  <div>over</div>
                  <div>hands</div>
                  <div>adapt</div>
                  <div>stairs</div>
                </div>
                <div>
                  <qrcode-vue :value="value" :size="size" level="H" class="ml-2" />
                </div>
              </div>
            </div>
          </div>
          <!-- Addresses -->
          <div class="grid grid-cols-2 gap-3">
            <div>
              <div class="flex items-center justify-between p-1 text-xs font-bold tracking-wider uppercase text-accent bg-accent bg-opacity-10">
                From
              </div>
              <div class="ml-1 text-sm">
                <div>{{ order.origin.contact_name }}</div>
                <div>{{ order.origin.contact_phone }}</div>
                <div>{{ order.origin.name }}</div>
                <div>{{ order.origin.address_1 }}</div>
                <div>{{ order.origin.address_2 }}</div>
                <div>{{ order.origin.city }}</div>
                <div>{{ countries[order.origin.country].name }}</div>
                <div>{{ order.origin.zip }}</div>
              </div>
            </div>
            <div>
              <div class="flex items-center justify-between p-1 text-xs font-bold tracking-wider uppercase text-accent bg-accent bg-opacity-10">
                To
              </div>
              <div class="ml-1 text-sm">
                <div>{{ order.destination.contact_name }}</div>
                <div>{{ order.destination.contact_phone }}</div>
                <div>{{ order.destination.name }}</div>
                <div>{{ order.destination.address_1 }}</div>
                <div>{{ order.destination.address_2 }}</div>
                <div>{{ order.destination.city }}</div>
                <div>{{ countries[order.destination.country].name }}</div>
                <div>{{ order.destination.zip }}</div>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-2 gap-3">
            <!-- Contents -->
            <div>
              <div class="flex items-center justify-between p-1 text-xs font-bold tracking-wider uppercase text-accent bg-accent bg-opacity-10">
                Details
              </div>
              <div class="ml-1 text-sm">
                1x Small Box
              </div>
            </div>
            <!-- Notes -->
            <div>
              <div class="flex items-center justify-between p-1 text-xs font-bold tracking-wider uppercase text-accent bg-accent bg-opacity-10">
                Notes
              </div>
              <div class="ml-1 text-sm">
                {{ order.origin.notes }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import ct from 'countries-and-timezones'

export default {
  name: 'BookWaybills',

  components: {
    QrcodeVue,
  },

  async created () {
    await this.getBooking()
  },
  
  computed: {
    countries () {
      return ct.getAllCountries()
    },
    
    multipickup () {
      return this.booking.origins && this.booking.origins.length > 1
    },

    multidelivery () {
      return this.booking.destinations && this.booking.destinations.length > 1
    },

    orders () {
      let orders = []
      if (this.multipickup) {
        for (let origin of this.booking.origins) {
          orders.push({
            origin,
            destination: this.booking.destinations[0],
          })
        }
      } else if (this.multidelivery) {
        for (let destination of this.booking.destinations) {
          orders.push({
            origin: this.booking.origins[0],
            destination
          })
        }
      }
      return orders
    }
  },

  data() {
    return {
      value: 'https://flt.onl',
      size: 64,
      booking: {}
    }
  },

  methods: {
    async getBooking () {
      try {
        const { data } = await this.$api.get(`waybills/${this.$route.query.booking}`)
        this.booking = data.booking
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },

    print () {
      window.print()
    }
  }
}
</script>

<style lang="postcss">
#page {
  @apply bg-white shadow-lg mx-auto block relative z-0;
  width: 21cm;
  height: 29.7cm;
  margin: 2cm auto;
}

@media print {
  #waybills #header {
    display:none;
  }

  #waybills #page {
    @apply shadow-none m-0;
  }
}
</style>